import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { cn } from '@/lib/utils';

interface VerifiedBadgeProps {
  verified?: boolean;
  className?: string;
  size?: number;
}

export default function VerifiedBadge({ verified = false, className, size = 14 }: VerifiedBadgeProps) {
  if (!verified) return null;

  return (
    <BadgeCheck
      size={size}
      className={cn('inline-block text-sky-500', className)}
      aria-label="Usuario verificado"
      title="Usuario verificado"
    />
  );
}